import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Loader } from '@/shared/ui/loader'

const LaboratoryResearchPage = lazy(
  () => import('@/pages/laboratoryResearch/ui/laboratoryResearchPage'),
)

const researchSearchSchema = z.object({
  tab: z.enum(['screening', 'blood-collection']).optional(),
})

export const Route = createFileRoute('/_protected/labarotaroyResearch/')({
  validateSearch: researchSearchSchema,
  // Keep the tab in the URL so the sidebar sub-items can highlight the active one.
  beforeLoad: ({ search }) => {
    if (!search.tab) {
      throw redirect({
        to: '/labarotaroyResearch',
        search: { tab: 'screening' },
      })
    }
  },
  component: () => (
    <Suspense fallback={<Loader />}>
      <LaboratoryResearchPage />
    </Suspense>
  ),
})
